import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import 'moment/locale/es';
import * as XLSX from 'xlsx';
import { LoaderSpinner } from '../../components/LoaderSpinner';
import { obtenerEstadisticasGlobalesAction } from '../../actions/campaignsActions';

export const GlobalCampaignDashboard = () => {
    const dispatch = useDispatch();

    const [fechaInicio, setFechaInicio] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [fechaFin, setFechaFin] = useState(moment().format('YYYY-MM-DD'));

    const globalStats = useSelector(state => state.campaigns.globalStats);
    const loadingGlobal = useSelector(state => state.campaigns.loadingGlobal);

    const buscar = () => {
        dispatch(obtenerEstadisticasGlobalesAction(fechaInicio, fechaFin));
    };

    const setRango = (tipo) => {
        let inicio, fin;
        fin = moment().format('YYYY-MM-DD');
        if (tipo === 'hoy') {
            inicio = moment().format('YYYY-MM-DD');
        } else if (tipo === '7dias') {
            inicio = moment().subtract(6, 'days').format('YYYY-MM-DD');
        } else if (tipo === 'mes') {
            inicio = moment().startOf('month').format('YYYY-MM-DD');
        } else if (tipo === 'anio') {
            inicio = moment().startOf('year').format('YYYY-MM-DD');
        }
        setFechaInicio(inicio);
        setFechaFin(fin);
        dispatch(obtenerEstadisticasGlobalesAction(inicio, fin));
    };

    const exportarExcel = () => {
        if (!globalStats || !globalStats.campaigns) return;

        const filas = globalStats.campaigns.map(c => ({
            'Nombre de la Campaña': c.campaign_name,
            'Fecha de Lanzamiento': c.launch_date,
            'Enviados Totales': c.total_sent,
            'Tasa de Apertura (%)': c.open_rate,
            'Tasa de Clics (%)': c.click_rate,
            'Bajas': c.unsubscribes
        }));

        const ws = XLSX.utils.json_to_sheet(filas);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Campañas');
        const fecha = moment().format('YYYY-MM-DD');
        XLSX.writeFile(wb, `Reporte_Consolidado_Campanas_${fecha}.xlsx`);
    };

    const kpis = globalStats ? globalStats.kpis : null;
    const campaigns = globalStats ? globalStats.campaigns : [];

    return (
        <div className="white_box QA_section card_height_100">
            <div className="p-4">
                <Link to="/mail_marketing" className="naranja mr-3">Email Marketing</Link>
                <span className="naranja">/ Dashboard Global</span>
            </div>

            {loadingGlobal && <LoaderSpinner />}

            <div className="px-4 pb-3">
                <div className="row align-items-end mb-3">
                    <div className="col-md-3">
                        <label>Fecha inicio</label>
                        <input
                            type="date"
                            className="form-control"
                            value={fechaInicio}
                            onChange={e => setFechaInicio(e.target.value)}
                        />
                    </div>
                    <div className="col-md-3">
                        <label>Fecha fin</label>
                        <input
                            type="date"
                            className="form-control"
                            value={fechaFin}
                            onChange={e => setFechaFin(e.target.value)}
                        />
                    </div>
                    <div className="col-md-2">
                        <button className="btn btn-primary w-100" onClick={buscar}>
                            <i className="fas fa-search mr-1"></i> Buscar
                        </button>
                    </div>
                </div>

                <div className="btn-group mb-4">
                    <button className="btn btn-outline-secondary btn-sm" onClick={() => setRango('hoy')}>Hoy</button>
                    <button className="btn btn-outline-secondary btn-sm" onClick={() => setRango('7dias')}>Últimos 7 días</button>
                    <button className="btn btn-outline-secondary btn-sm" onClick={() => setRango('mes')}>Este mes</button>
                    <button className="btn btn-outline-secondary btn-sm" onClick={() => setRango('anio')}>Año en curso</button>
                </div>

                {kpis && (
                    <div className="row mb-4">
                        <div className="col-md-3">
                            <div className="card text-center p-3">
                                <div style={{ fontSize: '13px', color: '#888' }}>Enviados Totales</div>
                                <div style={{ fontSize: '28px', fontWeight: 'bold' }}>{kpis.total_sent?.toLocaleString()}</div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="card text-center p-3">
                                <div style={{ fontSize: '13px', color: '#888' }}>Tasa de Apertura</div>
                                <div style={{ fontSize: '28px', fontWeight: 'bold' }}>{kpis.open_rate}%</div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="card text-center p-3">
                                <div style={{ fontSize: '13px', color: '#888' }}>Tasa de Clics</div>
                                <div style={{ fontSize: '28px', fontWeight: 'bold' }}>{kpis.click_rate}%</div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="card text-center p-3">
                                <div style={{ fontSize: '13px', color: '#888' }}>Bajas</div>
                                <div style={{ fontSize: '28px', fontWeight: 'bold' }}>{kpis.total_unsubscribes?.toLocaleString()}</div>
                            </div>
                        </div>
                    </div>
                )}

                {campaigns.length > 0 && (
                    <>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="mb-0">Detalle por Campaña</h6>
                            <button className="btn btn-success btn-sm" onClick={exportarExcel}>
                                <i className="fas fa-file-excel mr-1"></i> Exportar Excel
                            </button>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Nombre de la Campaña</th>
                                        <th>Fecha de Lanzamiento</th>
                                        <th>Enviados Totales</th>
                                        <th>Tasa de Apertura (%)</th>
                                        <th>Tasa de Clics (%)</th>
                                        <th>Bajas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {campaigns.map((row) => (
                                        <tr key={row.campaign_id}>
                                            <td>{row.campaign_name}</td>
                                            <td>{row.launch_date}</td>
                                            <td>{row.total_sent?.toLocaleString()}</td>
                                            <td>{row.open_rate}</td>
                                            <td>{row.click_rate}</td>
                                            <td>{row.unsubscribes}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}

                {!loadingGlobal && !globalStats && (
                    <p className="text-muted text-center mt-4">Selecciona un rango de fechas y presiona Buscar.</p>
                )}
            </div>
        </div>
    );
};
